import * as React from 'react';
import { useSelector } from 'react-redux';

import { manifestationTypeDescriptors } from '../../constants/descriptors';
import { isDescriptorActive } from '../../utils/filters';
import { FilterTooltip } from '../../components/FilterTooltip';
import { QuickFilterManifestationType } from './QuickFilterManifestationType';
import { IApplicationState } from '../../types/redux';

const getButtonText = (activeDescriptors: typeof manifestationTypeDescriptors): string => {
  if (activeDescriptors.length === 0) {
    return 'Кто продаёт';
  }

  const activeDescriptor = activeDescriptors[0];

  if (activeDescriptor.state === 'On') {
    return 'От застройщика';
  }

  if (activeDescriptor.state === 'Off') {
    return 'От агента или собственника';
  }

  return 'Кто продаёт';
};

export const FromDeveloper: React.FC = React.memo(() => {
  const jsonQuery = useSelector((state: IApplicationState) => state.jsonQuery);

  const activeDescriptors = React.useMemo(
    () => manifestationTypeDescriptors.filter(descriptor => isDescriptorActive(descriptor)(jsonQuery)),
    [jsonQuery],
  );

  const buttonText = React.useMemo(() => getButtonText(activeDescriptors), [activeDescriptors]);

  return (
    <FilterTooltip buttonText={buttonText} maxWidth={176} dataTestId="FromDeveloperQuickFilter">
      <QuickFilterManifestationType />
    </FilterTooltip>
  );
});

FromDeveloper.displayName = 'FromDeveloper';
